import { animate, scroll, inView, stagger } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const blockColumns = document.querySelector('.block-columns');

    // Check if the showcase  block exists
    if (!blockColumns) {
        return;
    }

    const blockColumnsColumns = blockColumns.querySelector('.block-columns__columns');

    // Animations
    inView(blockColumns, () => {
        // Animate the blockColumnsContent element
        animate(blockColumns.querySelector('.block-columns__content'), 
            { 
                opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
                transform: ['translateY(60px)', 'translateY(0)'], // Slide up (translateY transition).
            }, 
            { 
                duration: 0.6, // Animation duration.
                delay: 0.3     // Delay before animation starts.
            }
        );
        if(window.innerWidth >= 768 ) {
            scroll(
                animate(blockColumns.querySelector('.block-columns__inner'),
                    { y: [0, -250] },  // Move the heading from 0 to -10px along the Y-axis.
                    { ease: "ease-in-out" } // Easing.
                )
            );
        };
    }, {
        amount: 0.2 // Trigger when 20% of the element is visible
    });

    // Animations
    inView(blockColumnsColumns, () => {
        // Animate the blockColumnsContent element
        animate(blockColumnsColumns.querySelectorAll('div'), 
            { 
                opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
                transform: ['translateY(60px)', 'translateY(0)'], // Slide up (translateY transition).
            }, 
            { 
                duration: 0.6, // Animation duration.
                delay: stagger(0.3, { startDelay: 0.3 }) // Delay before animation starts.
            }
        );
    });
});